'use strict';

var AZ_LETTERS = 'a-zA-Z'; // Only A-Z letters, both mayus and minus
var ANY_LETTER = '\\p{L}'; // Any kind of letter from any language
var ANY_NUMBER = '0-9';
var ACCEPTED_PUNCTUATION_MARKS = '\'-\\.`´·'; // Includes: '()*+,-.`´·
var EXTENDED_ACCEPTED_SYMBOLS = 'ºª#\\/¿\\?¡!'; // Includes: ºª#/¿?¡!

var textCommonRegex = ANY_LETTER + ACCEPTED_PUNCTUATION_MARKS + ' ';
var textAndNumbersCommonRegex = textCommonRegex + ANY_NUMBER;
var textAndNumbersExtendedCommonRegex = textAndNumbersCommonRegex + EXTENDED_ACCEPTED_SYMBOLS; // Includes some extra characters: ºª#/¿?¡!

module.exports = {
    azLettersRegex: '^[' + AZ_LETTERS + ']+$',
    cifRegex: '^[' + ANY_NUMBER + 'a-zA-ZÀ-ÖØ-öø-ÿĀ-ž\'·\\-\\. ]*$',
    constants: {
        ANY_LETTER: ANY_LETTER
    },
    emailRegex: '^\\w+(?:[\\.+]?[\\-\\w]+)*@\\w+([\\.\\-]?\\w+)*(?:\\.\\w{2,63})+$',
    emojiRegex: '[\\u{1f300}-\\u{1f5ff}\\u{1f900}-\\u{1f9ff}\\u{1f600}-\\u{1f64f}\\u{1f680}-\\u{1f6ff}\\u{2600}-\\u{26ff}\\u{2700}-\\u{27bf}\\u{1f1e6}-\\u{1f1ff}\\u{1f191}-\\u{1f251}\\u{1f004}\\u{1f0cf}\\u{1f170}-\\u{1f171}\\u{1f17e}-\\u{1f17f}\\u{1f18e}\\u{3030}\\u{2b50}\\u{2b55}\\u{2934}-\\u{2935}\\u{2b05}-\\u{2b07}\\u{2b1b}-\\u{2b1c}\\u{3297}\\u{3299}\\u{303d}\\u{00a9}\\u{00ae}\\u{2122}\\u{23f3}\\u{24c2}\\u{23e9}-\\u{23ef}\\u{25b6}\\u{23f8}-\\u{23fa}]',
    generalPhoneRegex: '^(\\+[\\d]{1,4})?\\s*([\\d\\s]*)$',
    passwordRegex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[' + ANY_NUMBER + ']).{8,}$',
    textAndNumbersExtendedMultilineOrEmptyRegex: '^([' + textAndNumbersExtendedCommonRegex + '\\r\\n]+|^)$',
    textAndNumbersExtendedOrEmptyRegex: '^([' + textAndNumbersExtendedCommonRegex + ']+|^)$',
    textAndNumbersExtendedRegex: '^[' + textAndNumbersExtendedCommonRegex + ']{2,}$',
    textAndNumbersRegex: '^[' + textAndNumbersCommonRegex + ']{2,}$',
    textRegex: '^[' + textCommonRegex + ']+$',
    urlFromBylSiteRegex: '^http[s]?:\\/\\/[^\\/]*(?:bimbaylola|byl)[^\\/]*\\/.*$'
};
